export default __webpack_public_path__ + "media/images/borders/button-no-border-76c19c193e165e31d4d5a48f1d9a6dd1.svg";